<template>
  <div class="foot">
    <div class="foot-text">粤ICP备17002115号</div>
    <div class="foot-text">珠海移科智能科技有限公司版权所有</div>
  </div>
</template>

<script>
export default {
  name: 'FootInfo'
}
</script>

<style scoped>
.foot {
  text-align: left;
  padding-top: 0.7rem;
  padding-bottom: 2.3rem;
  color: #999999;
  font-size: 1.2rem;
  line-height: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/components/FootInfo.vue